import { Component } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { FormGroup, FormControl, Validators } from '@angular/forms';

import { State, getAccountsSortedByName } from '../../reducers';
import { SenderDomainActions } from '../../actions';
import { getSenderDomains } from '../../reducers';

const VALID_DOMAIN_NAME = /^[a-z0-9][a-z0-9-]{1,61}[a-z0-9](?:\.[a-z]{2,})+/i;

@Component({
  selector: 'app-email-sender-domain',
  templateUrl: './sender-domain.component.html',
  styleUrls: ['./sender-domain.component.scss'],
})
export class SenderDomainComponent {
  filter$ = new BehaviorSubject('');
  accounts$ = this.store.pipe(select(getAccountsSortedByName));
  senderDomains$ = combineLatest([
    this.store.pipe(select(getSenderDomains)),
    this.filter$,
  ]).pipe(
    map(([senderDomains, filter]) =>
      senderDomains.filter((senderDomain) =>
        Object.values(senderDomain)
          .join()
          .toLowerCase()
          .includes(filter.toLowerCase()),
      ),
    ),
  );

  createForm = new FormGroup({
    accountId: new FormControl('', Validators.required),
    fromDomain: new FormControl('', [
      Validators.required,
      Validators.pattern(VALID_DOMAIN_NAME),
    ]),
    senderDomain: new FormControl('', [
      Validators.required,
      Validators.pattern(VALID_DOMAIN_NAME),
    ]),
  });

  constructor(private readonly store: Store<State>) {}

  fetch(accountId: string) {
    this.store.dispatch(SenderDomainActions.fetchRequest({ accountId }));
  }

  create() {
    this.store.dispatch(
      SenderDomainActions.createRequest(this.createForm.value),
    );

    this.createForm.reset();
  }

  delete(domainId: string, accountId: string) {
    this.store.dispatch(
      SenderDomainActions.deleteRequest({ domainId, accountId }),
    );
  }
}
